import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getGrossMarginLevelDefaultValue, getGrossMarginLevelSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { saveGrossMarginLevel } from "../api-handler/api-handler";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const EditGrossMarginLevelForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const EditHashId = searchParams.get("HashId");
    const spinnerCtx = useContext(DisplaySpinnerContext);
    const settingsConfig = useSelector(selectSessionConfig);
    const navigationData = location.state;

    const [formdata, setFormdata] = useState({
        schema: getGrossMarginLevelSchema(navigationData.gmLevelList),
        appformdata: null,
    });

    const defaultValue = getGrossMarginLevelDefaultValue();

    const handleCancel = () => {
        try {
            navigate(`/${navigationData.gmtype}`);
        } catch (err) {
            alert(err);
        }
    };

    const onGrossMarginLevelSubmit = async (data, formhandler) => {
        console.log("onGrossMarginLevelSubmit");
        const { reset, clearErrors } = formhandler;
        try {
            clearErrors();
            spinnerCtx.setLoadingIndicator(true);
            const status = await saveGrossMarginLevel(data, {
                EditHashId,
                settingsConfig,
                formdata: formdata.appformdata,
            });

            if (status?.responseStatus === 200) {
                notifyToast("Sent for Approval", ToastType.SUCCESS);
                handleCancel();
            } else {
                notifyToast(status.errorMessage ? status.errorMessage : "Gross Margin Level failed", ToastType.ERROR);
                spinnerCtx.setLoadingIndicator(false);
            }
            if (status?.error) {
                reset(
                    { ...data },
                    {
                        keepValues: true,
                        keepSubmitCount: false,
                        keepDirty: true,
                        keepTouched: true,
                    }
                );
            }
        } catch (err) {
            reset(
                { ...data },
                {
                    keepValues: true,
                    keepSubmitCount: false,
                    keepDirty: true,
                    keepTouched: true,
                }
            );
            alert(err);
        }
    };

    useEffect(() => {
        const setFormSchema = () => {
            try {
                let _formData = navigationData ? { ...navigationData } : null;

                if (_formData) {
                    const _formattedRange = navigationData.gmLevelList
                        .filter((item) => item.id !== _formData.HashId)
                        .map((item) => ({
                            startRange: parseFloat(item.startRange),
                            endRange: parseFloat(item.endRange),
                        }));
                    setFormdata((prevstate) => ({
                        ...prevstate,
                        schema: getGrossMarginLevelSchema(_formattedRange),
                        appformdata: getGrossMarginLevelDefaultValue(_formData),
                    }));
                }
            } catch (err) {
                alert(err);
            } finally {
                spinnerCtx.setLoadingIndicator(false);
            }
        };

        spinnerCtx.setLoadingIndicator(true);

        setFormSchema();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AppFormRootContainer>
            <TabPanel
                tabs={[
                    {
                        icon: "",
                        label: t("navigationMenu.approvalMatrix"),
                        children: (
                            <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                                <AppForm onSubmit={onGrossMarginLevelSubmit}>
                                    <DynamicFormContainer
                                        header={navigationData.gmtype === "gmsales" ? t("createGrossMarginLevel.editSalesGrossMarginLevel") : t("createGrossMarginLevel.editPercentileGrossMarginLevel")}
                                        onCancel={handleCancel}
                                    />
                                </AppForm>
                            </FormContextProvider>
                        ),
                    },
                ]}
                selectedTab="0"
                onTabChange={() => { }}
            />
        </AppFormRootContainer>
    );
};

export default EditGrossMarginLevelForm;
